/**
 * @generated SignedSource<<29cce65aa673bc50727985e8b9f5aaaa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type QUOTE_DECISION = "APPROVED" | "DECLINED" | "REVISING" | "%future added value";
export type RecordQuoteDecisionInput = {
  quoteId: string;
  decision: QUOTE_DECISION;
  clientContactId?: string | null;
  reason?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type recordQuoteDecisionMutation$variables = {
  input: RecordQuoteDecisionInput;
};
export type recordQuoteDecisionMutation$data = {
  readonly recordQuoteDecision: {
    readonly quote: {
      readonly id: string;
      readonly status: string | null;
    } | null;
    readonly project: {
      readonly id: string;
      readonly quoteActivities: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly eventType: string | null;
            readonly revisionNumber: number | null;
            readonly createdAt: string | null;
            readonly clientContactName: string | null;
            readonly clientContact: {
              readonly id: string;
            } | null;
            readonly reason: string | null;
            readonly person: {
              readonly id: string;
              readonly fullName: string | null;
            } | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};
export type recordQuoteDecisionMutation = {
  variables: recordQuoteDecisionMutation$variables;
  response: recordQuoteDecisionMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RecordQuoteDecisionPayload",
    "kind": "LinkedField",
    "name": "recordQuoteDecision",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Quote",
        "kind": "LinkedField",
        "name": "quote",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectType",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 100
              }
            ],
            "concreteType": "QuoteActivityConnection",
            "kind": "LinkedField",
            "name": "quoteActivities",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QuoteActivityEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QuoteActivity",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "eventType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "revisionNumber",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "clientContactName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ClientContact",
                        "kind": "LinkedField",
                        "name": "clientContact",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "reason",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Person",
                        "kind": "LinkedField",
                        "name": "person",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "fullName",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "quoteActivities(first:100)"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "recordQuoteDecisionMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "recordQuoteDecisionMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "8109130ad8529eb305a06286dc13e11f",
    "id": null,
    "metadata": {},
    "name": "recordQuoteDecisionMutation",
    "operationKind": "mutation",
    "text": "mutation recordQuoteDecisionMutation(\n  $input: RecordQuoteDecisionInput!\n) {\n  recordQuoteDecision(input: $input) {\n    quote {\n      id\n      status\n    }\n    project {\n      id\n      quoteActivities(first: 100) {\n        edges {\n          node {\n            id\n            eventType\n            revisionNumber\n            createdAt\n            clientContactName\n            clientContact {\n              id\n            }\n            reason\n            person {\n              id\n              fullName\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d75ecac1057f4bc5328e2f1ec282faca";

export default node;
